import MenuBarController from './menu-bar.controller';

angular
	.module('app.menu-bar', [])
	.component('appMenuBar', {
		templateUrl: 'layout/menu-bar/menu-bar.html',
		controller: MenuBarController
	});
